<template>
  <div id="app">
    <div id="header">
      <img src="./assets/adelphi-logo.png" />
    </div>
    <div v-if="logged_in === true">
      <div>
      <Questions />
      </div>
      <!-- <div v-else class="coming-soon">
        <h1>Launching Monday, June 15.</h1>
      </div> -->
    </div>
    <div v-else>
      You need to log in
      <v-btn @click="loginRedirect">Log In</v-btn>
    </div>
  </div>
</template>

<script>
import Questions from './components/Questions'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    Questions
  },

  data:() => ({
    logged_in: false,
    username: null
  }),

  mounted() {
     axios.get('./remote-apis/auth.php')
      .then(response => {
          const json = response.data
          console.log(response.data)
          if (json['msg'] == 'authenticated') {
              this.logged_in = true
              this.username = response.data.username
          }else {
              this.loginRedirect()
          }
      })
      .catch(error => {
          window.console.error(error)
          this.loginRedirect()
      })
  },

  methods: {
    loginRedirect() {
       window.location = './remote-apis/auth-redirect.php'
    }
  }
}
</script>

<style>
html, body {
  height: 100%;
}
body {

  margin:0;
  padding: 0;
  /* background-color: #ffb500;
  color: #000; */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
}

#app h1 {
  text-align: center;
}

#header {
  display: none;
  background-color: #ffb500;
  height: 128px;
}

.questions {

  margin-top: 60px;
  padding: 10px;
}

.main-button {
  display:block;
  border: 0;
  min-height: 100px;
  margin-top: 20px;
  font-weight: bold;
  outline: none;
  background-color: #FFF;
  border: 1px solid #000;
}

.btn-set, .input-set {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.input-set select {
  min-height: 50px; 
  height: 50px;
}

.btn-set button {
  border: 0;
  min-height: 50px;
  margin-top: 20px;
  font-weight: bold;
  outline: none;
  border-radius: 7px;
  background-color: #F2F2F7;
}

.btn-set button.yes {
  background-color: rgba(247, 206, 70, 0.18);
  border: 2px solid rgb(247, 206, 70);
}
.btn-set button.no {
  background-color: rgba(247, 206, 70,0.18);
  border: 2px solid rgb(247, 206, 70);
}

.question {
  font-weight: bold;
}

.submit-btn {
  margin-top: 30px;
  width: 100%;
  min-height: 50px;
  background-color: rgb(247, 206, 70);
  font-weight: bold;
  border: 0;
  outline: none;
  border-radius: 7px;
}

.result {
  
  text-align: center;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  padding: 10px;
}

.cleared {
  color: #FFF;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100vh;
}

.cleared-name {
  font-size: 3.0em;
  font-weight: bold;
  background-color: #FFF;
  color: #518354;
}

.cleared-message {
  font-size: 4.0em;
  text-transform: uppercase;

}

.cleared-instructions {
  font-size: 2.0em;
  background-color: #FFF;
  color: #518354;
}

.cleared .stamp {
  flex-shrink: 6;
  display: flex;
  flex-direction: column;
  justify-content: end;

}
.cleared .time {
  font-size: 2.0em;
}

.cleared .month {
  font-size: 6.0em;
  font-weight: bold;
}

.cleared .day {
  font-size: 12.0em;
  font-weight: bold;
  line-height: 0.9em;
  height: 1em;
}

.cleared .year {
  font-size: 6.0em;
  font-weight: bold;
}

.cleared-background {
  background-color: #518354;
}

.not-cleared-background {
  background-color: red;
  color: black;
}

.not-cleared {
  color: #000;
}

.not-cleared strong {
  color: #9F302B;
  font-weight: bold;
  text-transform: uppercase;
}

.coming-soon {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: #ffb500;
  height: 100vh;
  padding: 10px;
}

.reason-text-field {
  width: 100%;
  height: 100px;
}

@media (min-width: 1264px) {
  .cleared-background {
    background-color: #FFF;
  }
  .result .cleared {
    margin: 50px auto;
    width: 50%;
    padding: 10px 0;
    background-color: #518354;
    border-radius: 15px;
    font-size: 70%;
    justify-content: center;
    height: auto;
    max-height: 700px;

  }

  .result .cleared .stamp {
    flex-grow: 9;
  }

  #header {
    display: block;
  }

  .coming-soon {
    background-color: #FFF;
    justify-content: start; 
  }
}
</style>
